//dialogo-mensaje.component.js
"use strict";

import template from './dialogo-mensaje.view.html';
import { DIALOGO_MENSAJE_CONTROLLER } from './dialogo-mensaje.controller';
import './dialogo-mensaje.less';

let DIALOGO_MENSAJE_COMPONENT = {
    restrict: 'E',
    template,
    controller: DIALOGO_MENSAJE_CONTROLLER,
    controllerAs: "DialogoMensaje",
    bindings: {
        titulo: '<',
        mensaje: '<',
        icono: '<',
        onAceptar: '&',
        txtAceptar: '<',
        onCancelar: '&',
        txtCancelar: '<',
        onCerrar: '&',
        close: '&',
        origen: '<'
    }
};

export { DIALOGO_MENSAJE_COMPONENT };
